/* eslint-disable import/prefer-default-export */
import NBColor, { NBColorStrings } from 'enums/NBColor'
// @ts-ignore
import { ref } from '@netbasequid/theme'
import { Theme } from 'features/ui/types'

export const getAnnotationColor = (color: NBColorStrings, mode: Theme) => {
  const isLight = mode === 'light'
  switch (color) {
    case NBColor.RED:
      return ref.color.red[isLight ? 800 : 500]
    case NBColor.ORANGE:
      return ref.color.orange[isLight ? 700 : 400]
    case NBColor.GREEN:
      return ref.color.chartreuse[isLight ? 900 : 600]
    case NBColor.GREY:
    default:
      return ref.color.gray[isLight ? 800 : 600]
  }
}
